import React from 'react';

export const MaintenancePage = () => {
  return (
    <main className="relative min-h-screen overflow-hidden bg-brand-primary text-white">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(0,167,181,0.2),transparent_32%),radial-gradient(circle_at_85%_75%,rgba(49,82,115,0.35),transparent_38%),linear-gradient(135deg,#011844_0%,#062c49_52%,#011844_100%)]" />
      <div className="absolute -right-32 top-1/4 h-96 w-96 rounded-full bg-brand-accent/10 blur-3xl" />
      <div className="absolute -bottom-40 -left-20 h-96 w-96 rounded-full bg-brand-secondary/20 blur-3xl" />

      <div className="relative z-10 flex min-h-screen flex-col px-6 py-8 lg:px-16 lg:py-12">
        <header>
          <img
            src="https://media-manager-c.questera.ai/greta-media/4948ae8bd3a71eaecd010e3b75a418c9afeda68ebd57283642e35d04cbb3fca3a3104393b4fae87688db585a45c44e03/images/aW1hZ2UvcG5n/24152a83edb2ff25ab9bc42b276df3ad.png"
            alt="EPOQ Mobility"
            className="h-10 w-auto object-contain brightness-0 invert"
          />
        </header>

        <section className="flex flex-1 items-center">
          <div className="max-w-2xl">
            <span className="mb-6 block text-xs font-semibold uppercase tracking-[0.3em] text-cyan-200">
              EPOQ Mobility
            </span>
            <h1 className="mb-8 max-w-xl font-space text-5xl font-semibold leading-[1.05] tracking-tight text-white sm:text-6xl lg:text-7xl">
              EPOQ Mobility is being updated
            </h1>
            <p className="max-w-lg text-lg font-light leading-relaxed text-slate-200 sm:text-xl">
              We are currently updating our website and will be back shortly.
            </p>
            <div className="mt-12 h-px w-24 bg-brand-accent" />
          </div>
        </section>

        <footer className="text-xs uppercase tracking-[0.2em] text-slate-400">
          Autonomous electric logistics
        </footer>
      </div>
    </main>
  );
};